import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=815435e2&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=815435e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815435e2",
  null
  
)

export default component.exports